<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <h4 class="mb-4 bold">Quản lý mẫu văn bản</h4>
        <div class="main-body mt-1">
          <div class="main-body-search">
            <div class="d-flex justify-content-end mb-3">
              <el-button round class="btn-default" type="info" @click="toggleSearch">
                Ẩn/hiện tìm kiếm <i class="el-icon-search ml-1"></i>
              </el-button>
              <el-button round class="btn-default" type="primary" @click="openCreateDialog">
                Thêm mới <i class="el-icon-plus ml-1"></i>
              </el-button>
            </div>
            <b-collapse :visible="mData.tableRules.showFormSearch" id="ddaTemplateSearch" class="mb-3">
              <el-card>
                <el-form ref="searchForm" label-position="top" @submit.native.prevent
                  :model="mData.tableRules.dataSearch.value">
                  <b-row align-v="center">
                    <b-col md="9">
                      <el-form-item label="Điều kiện" label-width="100px">
                        <el-input v-model="mData.tableRules.dataSearch.value.keyword"
                          placeholder="Nhập mã mẫu, tên mẫu hoặc nội dung tìm kiếm..." clearable></el-input>
                      </el-form-item>
                      <!-- </el-col> -->
                    </b-col>
                    <b-col md="3">
                      <el-button class="btn-default w-100" round type="primary" @click="searchTable">
                        Tìm kiếm
                      </el-button>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="4">
                      <el-form-item label="Mã mẫu" label-width="100px">
                        <el-input v-model="mData.tableRules.dataSearch.value.code" clearable
                          @change="normalizeSearchCode" />
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Loại mẫu" label-width="100px">
                        <el-select v-model="mData.tableRules.dataSearch.value.dda_category_id" clearable filterable
                          class="w-100">
                          <el-option v-for="item in dataDefault.categories" :key="item.id" :label="item.name"
                            :value="item.id" />
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Trạng thái" label-width="100px">
                        <el-select v-model="mData.tableRules.dataSearch.value.disabled" clearable class="w-100">
                          <el-option v-for="item in dataDefault.lockStatuses" :key="item.value" :label="item.label"
                            :value="item.value" />
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-form>
              </el-card>
            </b-collapse>
          </div>

          <div class="main-body-table">
            <el-table :data="mData.tableRules.data" border @sort-change="sortTable"
              :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }">
              <el-table-column label="STT" width="60" align="center">
                <template slot-scope="scope">
                  {{ mData.tableRules.offset + scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="code" label="Mã mẫu" min-width="160" sortable="custom" />
              <el-table-column prop="name" label="Tên mẫu văn bản" min-width="260" sortable="custom" />
              <el-table-column prop="dda_category_name" label="Loại mẫu" min-width="180" />
              <el-table-column prop="config.page_orientation" label="Khổ giấy" width="120" align="center">
                <template slot-scope="scope">
                  {{ formatOrientation(scope.row.config) }}
                </template>
              </el-table-column>
              <el-table-column label="Khóa" width="70" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.disabled" @change="toggleDisabled(scope.row)" />
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" width="120" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" plain round type="primary" @click="openUpdateDialog(scope.row.id)">
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button size="mini" plain round type="danger" @click="remove(scope.row.id)">
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-8 offset-md-4 text-right">
                <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange"
                  :page-sizes="mData.tableRules.lengthMenu" :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page" background layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total" :pager-count="5" />
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="mData.viewMode === 'create' ? 'Thêm mới mẫu văn bản' : 'Cập nhật mẫu văn bản'"
      :visible.sync="formDialog" width="900px" :before-close="resetForm" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form v-if="formDialog" ref="formDialog" :model="mData.dataForm" :rules="mData.validForm" label-position="top"
        @submit.native.prevent>
        <b-row>
          <b-col md="4">
            <el-form-item label="Mã mẫu văn bản" prop="code">
              <el-input v-model.trim="mData.dataForm.code" @change="normalizeFormValues" />
            </el-form-item>
          </b-col>
          <b-col md="8">
            <el-form-item label="Tên mẫu văn bản" prop="name">
              <el-input v-model="mData.dataForm.name" @change="normalizeFormValues" />
            </el-form-item>
          </b-col>
          <b-col md="6">
            <el-form-item label="Loại mẫu" prop="dda_category_id">
              <el-select v-model="mData.dataForm.dda_category_id" filterable clearable>
                <el-option v-for="item in dataDefault.categories" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </b-col>
          <b-col md="3">
            <el-form-item label="Khổ giấy" prop="config.page_size">
              <el-select v-model="mData.dataForm.config.page_size">
                <el-option label="A4" value="A4" />
                <el-option label="A3" value="A3" />
                <el-option label="Letter" value="Letter" />
              </el-select>
            </el-form-item>
          </b-col>
          <b-col md="3">
            <el-form-item label="Chiều giấy" prop="config.page_orientation">
              <el-select v-model="mData.dataForm.config.page_orientation">
                <el-option label="Dọc" value="Portrait" />
                <el-option label="Ngang" value="Landscape" />
              </el-select>
            </el-form-item>
          </b-col>
          <b-col md="3">
            <el-form-item label="Lề trên" prop="config.margin_top">
              <el-input-number v-model="mData.dataForm.config.margin_top" :min="0" controls-position="right" />
            </el-form-item>
          </b-col>
          <b-col md="3">
            <el-form-item label="Lề dưới" prop="config.margin_bottom">
              <el-input-number v-model="mData.dataForm.config.margin_bottom" :min="0" controls-position="right" />
            </el-form-item>
          </b-col>
          <b-col md="3">
            <el-form-item label="Lề trái" prop="config.margin_left">
              <el-input-number v-model="mData.dataForm.config.margin_left" :min="0" controls-position="right" />
            </el-form-item>
          </b-col>
          <b-col md="3">
            <el-form-item label="Lề phải" prop="config.margin_right">
              <el-input-number v-model="mData.dataForm.config.margin_right" :min="0" controls-position="right" />
            </el-form-item>
          </b-col>
          <b-col md="12">
            <el-form-item label="File mẫu">
              <el-upload class="template-upload" action="" :auto-upload="false" :show-file-list="false"
                :on-change="handleFileChange" accept=".docx,.pdf,.html,.htm">
                <el-button size="small" type="primary" icon="el-icon-upload">Upload file để scan sang HTML (.docx, .pdf,
                  .html)</el-button>
              </el-upload>
            </el-form-item>
          </b-col>
        </b-row>
        <div class="text-center mt-2">
          <el-button round class="btn-default" @click="submitForm">
            {{ mData.viewMode === "create" ? "Lưu" : "Cập nhật" }}
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import DataService from "@/service/DataService";
import LanguageService from "@/service/LanguageService";
import MethodService from "@/service/MethodService";
import DdaCategoryApi from "@/moduleApi/DdaCategoryApi";
import DdaTemplateApi from "@/moduleApi/DdaTemplateApi";
import DdaTemplateListModel from "./DdaTemplateListModel";
import mammoth from "mammoth";
import * as PDFJS from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      formDialog: false,
      dataDefault: {
        categories: [],
        categoryMap: {},
        lockStatuses: DataService.listTrangThaiKhoa,
      },
      mData: {
        id: null,
        viewMode: "create",
        dataForm: MethodService.copyObject(DdaTemplateListModel.dataForm),
        validForm: DdaTemplateListModel.validForm,
        tableRules: MethodService.copyObject(DdaTemplateListModel.tableRules),
      },
      editorConfig: {
        height: 400,
        toolbar: [
          { name: "document", items: ["Source", "-", "NewPage", "Preview", "Print", "-", "Templates"] },
          { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
          { name: "editing", items: ["Find", "Replace", "-", "SelectAll"] },
          "/",
          { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "CopyFormatting", "RemoveFormat"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote", "CreateDiv", "-", "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          { name: "insert", items: ["Image", "Table", "HorizontalRule", "Smiley", "SpecialChar", "PageBreak", "Iframe"] },
          "/",
          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] },
        ],
        removeButtons: "About",
        removePlugins: "exportpdf",
      },
      editorConfigMini: {
        height: 100,
        toolbar: [
          { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "-", "RemoveFormat"] },
          { name: "paragraph", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "styles", items: ["FontSize"] },
        ],
        removePlugins: "exportpdf",
      },
    };
  },
  methods: {
    async loadCategories() {
      const res = await DdaCategoryApi.list({ limit: 1000, sort: "name" });
      this.dataDefault.categories = res.result || [];
      this.dataDefault.categoryMap = this.dataDefault.categories.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
    },
    async initTable() {
      const dataFilter = {
        filters: this.mData.tableRules.filters,
        limit: this.mData.tableRules.limit,
        offset: this.mData.tableRules.offset,
        sort: this.mData.tableRules.sort,
      };
      this.$router.replace({
        name: "Admin-DocumentDrafting-template-list",
        query: {
          ...dataFilter,
          page: this.mData.tableRules.page,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      }).catch(() => { });

      const res = await DdaTemplateApi.list(dataFilter);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.data = (res.result || []).map((item) => ({
        ...item,
        dda_category_name: this.dataDefault.categoryMap[item.dda_category_id] || "",
      }));
    },
    normalizeSearchCode() {
      if (this.mData.tableRules.dataSearch.value.code) {
        this.mData.tableRules.dataSearch.value.code = this.mData.tableRules.dataSearch.value.code.trim().toUpperCase();
      }
    },
    normalizeFormValues() {
      if (this.mData.dataForm.code) {
        this.mData.dataForm.code = this.mData.dataForm.code.trim().toUpperCase();
      }
      if (this.mData.dataForm.name) {
        this.mData.dataForm.name = this.mData.dataForm.name.trim();
      }
    },
    searchTable() {
      if (this.mData.tableRules.dataSearch.value.name) {
        this.mData.tableRules.dataSearch.value.name = this.mData.tableRules.dataSearch.value.name.trim();
      }
      this.normalizeSearchCode();
      this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.page = 1;
      this.initTable();
    },
    toggleSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-DocumentDrafting-template-list",
        query: {
          ...this.$route.query,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      }).catch(() => { });
    },
    sortTable(column) {
      if (column.order === "ascending") this.mData.tableRules.sort = column.prop;
      else if (column.order === "descending") this.mData.tableRules.sort = `-${column.prop}`;
      else this.mData.tableRules.sort = "";
      this.initTable();
    },
    onSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.mData.tableRules.page = 1;
      this.mData.tableRules.offset = 0;
      this.initTable();
    },
    onCurrentChange(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset = (page - 1) * this.mData.tableRules.limit;
      this.initTable();
    },
    openCreateDialog() {
      this.mData.viewMode = "create";
      this.formDialog = true;
    },
    async openUpdateDialog(id) {
      this.mData.viewMode = "update";
      this.mData.id = id;
      const res = await DdaTemplateApi.findById(id);
      if (res.result) {
        this.mData.dataForm = this.withTemplateDefaults(res.result);
        this.formDialog = true;
      }
    },
    withTemplateDefaults(data) {
      const config = {
        ...DdaTemplateListModel.defaultConfig(),
        ...(data.config || {}),
      };
      const content = {
        header: "",
        body: "",
        footer: "",
        ...(data.content || {}),
      };
      return {
        ...MethodService.copyObject(DdaTemplateListModel.dataForm),
        ...data,
        config,
        content,
      };
    },
    async handleFileChange(file) {
      if (!file.raw) return;
      const extension = file.name.split(".").pop().toLowerCase();
      console.log("DDA Scanning file:", file.name, "Extension:", extension);

      try {
        if (extension === "docx") {
          const arrayBuffer = await this.readFileAsArrayBuffer(file.raw);
          const result = await mammoth.convertToHtml({ arrayBuffer });
          this.mData.dataForm.content.body = result.value;
          window.toastr.success("Đã chuyển đổi Docx sang HTML");
        } else if (extension === "pdf") {
          await this.scanPdfToHtml(file);
        } else if (extension === "html" || extension === "htm") {
          const text = await this.readFileAsText(file.raw);
          this.mData.dataForm.content.body = text;
          window.toastr.success("Đã nạp nội dung HTML");
        }
      } catch (error) {
        console.error("DDA File conversion error:", error);
        window.toastr.error("Lỗi khi chuyển đổi file");
      }
    },
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsArrayBuffer(file);
      });
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsText(file);
      });
    },
    async scanPdfToHtml(file) {
      console.log("DDA Starting PDF scan...");
      try {
        PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        const arrayBuffer = await this.readFileAsArrayBuffer(file.raw);
        const loadingTask = PDFJS.getDocument({ data: arrayBuffer });
        const pdf = await loadingTask.promise;
        console.log("DDA PDF loaded, pages:", pdf.numPages);

        let fullHtml = "";
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();

          let lastX = -1;
          let lastY = -1;
          let lastWidth = 0;
          let pageHtml = "";

          for (const item of textContent.items) {
            const x = item.transform[4];
            const y = item.transform[5];

            // New line detection
            if (lastY !== -1 && Math.abs(lastY - y) > 5) {
              pageHtml += "<br/>";
            } else if (lastX !== -1) {
              // Same line - check for word spacing
              const gap = x - (lastX + lastWidth);
              // If gap is significant, add a space (usually > 2 units)
              if (gap > 1.5) {
                pageHtml += " ";
              }
            }

            pageHtml += item.str;

            lastX = x;
            lastY = y;
            lastWidth = item.width;
          }
          fullHtml += `<div style="margin-bottom: 20px;">${pageHtml}</div>`;
          if (i < pdf.numPages) fullHtml += "<hr/>";
        }

        this.mData.dataForm.content.body = `<div>${fullHtml}</div>`;
        console.log("DDA PDF conversion complete");
        window.toastr.success("Đã trích xuất nội dung PDF sang HTML");
      } catch (err) {
        console.error("DDA PDF conversion error:", err);
        throw err;
      }
    },
    async submitForm() {
      this.normalizeFormValues();
      this.$refs.formDialog.validate(async (valid) => {
        if (!valid) return;
        const data = this.withTemplateDefaults(this.mData.dataForm);
        console.log("Submit request data:", data);
        try {
          if (this.mData.viewMode === "create") {
            await DdaTemplateApi.create(data);
          } else {
            data.id = this.mData.id;
            await DdaTemplateApi.update(data);
          }
          this.resetForm();
          await this.initTable();
        } catch (error) {
          window.toastr.error(error.message || (this.mData.viewMode === "create" ? "Thêm mới thất bại" : "Cập nhật thất bại"));
        }
      });
    },
    async toggleDisabled(row) {
      try {
        await DdaTemplateApi.update({ id: row.id, disabled: row.disabled });
      } catch (error) {
        row.disabled = !row.disabled;
        window.toastr.error(error.message || "Cập nhật trạng thái thất bại");
      }
    },
    remove(id) {
      this.$confirm(this.aLang.c_deleteConfirm, {
        confirmButtonText: this.aLang.c_agree,
        cancelButtonText: this.aLang.c_cancel,
        type: "warning",
      }).then(async () => {
        try {
          await DdaTemplateApi.delete(id);
          await this.initTable();
        } catch (error) {
          window.toastr.error(error.detail || error.message || "Xóa thất bại");
        }
      }).catch(() => { });
    },
    resetForm() {
      this.formDialog = false;
      this.mData.id = null;
      this.mData.viewMode = "create";
      this.mData.dataForm = MethodService.copyObject(DdaTemplateListModel.dataForm);
      if (this.$refs.formDialog) {
        this.$refs.formDialog.resetFields();
      }
    },
    syncFromRoute() {
      const query = this.$route.query;
      if (query.limit) this.mData.tableRules.limit = parseInt(query.limit);
      if (query.page) this.mData.tableRules.page = parseInt(query.page);
      this.mData.tableRules.offset = (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      if (query.sort) {
        this.mData.tableRules.sort = query.sort;
        this.mData.tableRules.defaultSort[0] = query.sort.replace("-", "");
        this.mData.tableRules.defaultSort[1] = query.sort.startsWith("-") ? "descending" : "ascending";
      }
      if (query.showFormSearch === "true") this.mData.tableRules.showFormSearch = true;
      if (query.showFormSearch === "false") this.mData.tableRules.showFormSearch = false;
      if (query.filters) {
        this.mData.tableRules.filters = query.filters;
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(query.filters);
        const nameMatch = query.filters.match(/\$vn_text=([^&]*)(&|$)/);
        const codeMatch = query.filters.match(/code:regex_i:([^&]*)(&|$)/);
        if (nameMatch) this.$set(this.mData.tableRules.dataSearch.value, "name", decodeURIComponent(nameMatch[1]));
        if (codeMatch) this.$set(this.mData.tableRules.dataSearch.value, "code", decodeURIComponent(codeMatch[1]));
      }
    },
    formatOrientation(config) {
      const size = config && config.page_size ? config.page_size : "A4";
      const orientation = config && config.page_orientation === "Landscape" ? "Ngang" : "Dọc";
      return `${size} / ${orientation}`;
    },
  },
  async created() {
    this.syncFromRoute();
    await this.loadCategories();
    await this.initTable();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input-number {
  width: 100%;

  .el-input__inner {
    text-align: left;
  }
}
</style>
